import React, { useEffect, useState } from 'react';
// reactstrap components
import {
    FormGroup,
    Input,
    Row,
    Col
} from "reactstrap";

import BasicModal from '../../../../components/Modals/BasicModal'
import {titleCase} from '../../../../utils/views/pages/Dynamics'

const ManagementInformation = (props) => {
    const coupon = props.coupon
    const formDisabled = props.formDisabled
    const setCoupon = props.setCoupon
    const [showModal, setShowModal] = useState(false)
    const [warning, setWarning] = useState("")
    const validations = props.validations

    let validateField = (e) => {
        //console.log(!e.target.value.trim() && e.target.required)
        if (!e.target.value.trim() && e.target.required) {

            setWarning('The field \'' + titleCase(e.target.name) + '\' is required!')
            setShowModal(true)

        } else {
            if (validations[e.target.name] && !validations[e.target.name].test(e.target.value)) {
                setWarning('Invalid ' + titleCase(e.target.name))
                setShowModal(true)
            }
        }

    }

    let handleInput = (e) => {

        coupon[e.target.name] = e.target.value
        setCoupon(coupon)

    }

    return (
        <>
            <h6 className="heading-small text-muted mb-4">
                Management information
            </h6>
            <div className="pl-lg-4">
                            
                <Row>
                    <Col md="12">
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-detail"
                            >
                                Details
                            </label>
                            <Input
                                className="form-control-alternative"
                                defaultValue={coupon?.detail}
                                id="input-detail"
                                name="detail"
                                placeholder="Coupon Details"
                                type="textarea"
                                rows="5"
                                disabled={formDisabled}
                                onChange={handleInput}
                                required={false}
                                onBlur={validateField}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                
            </div>

            <BasicModal
                title="Warning"
                message={warning}
                showModal={showModal}
                setShowModal={setShowModal} />

        </>
    )
}

export default ManagementInformation;